// One wording for a resume a finished batch could not turn into a candidate.
// Every screen that reports a finalized batch reads it from here — the review
// page, the upload page and the emailed confirmation page all used to word it
// themselves, and all three led with "duplicate", so a resume that failed for
// any other cause was reported as one.
//
// The server sends `message`. `reason` is the fallback for a batch that was
// confirmed before the server carried one.
export const droppedFileReason = (file) =>
  file?.message ||
  (file?.reason === "duplicate" ? "This candidate has already applied to this job." : "We couldn't save this resume. Check its details and upload it again.");

// The one-line count. Says how many were skipped, never why — the per-file
// lines carry the reason, and guessing it here is what made the copy wrong.
export const droppedSummary = (count) => `${count} ${count === 1 ? "resume was" : "resumes were"} skipped:`;
